import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import {
  editComplaint,
  editInvestigation,
} from "services/advocateComplaintService";
import { AdvocateComplaints, Investigation } from "types";
import { LoadingIcon } from "utils/constant";
import {
  ADVOCATE_INVESTIGATION_STATUS,
  COMPLIANT_STATUS,
} from "utils/constantValues";
import { useTranslation } from "contexts/i18nContext";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: AdvocateComplaints;
  investigationData: Investigation;
  onRefresh: any;
}

export default function RejectChargeDocument({
  isOpen,
  setIsOpen,
  complaintData,
  investigationData,
  onRefresh,
}: ModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    reject_coment: "",
    reject_coment_date: "",
    status: ADVOCATE_INVESTIGATION_STATUS?.CLOSED,
    complaint: null,
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // setError(null);
    // setSuccess(false);

    if (!investigationData) return;

    const data = {
      ...formState,
      admin_unit_id: complaintData?.admin_unit_id || "",
      org_id: complaintData?.org_id || "",
      accused_advocate_name: complaintData?.accused_name || "",
      user_id_accused_advocate: complaintData?.userid_accused_name || "",
      accused_license_number: complaintData?.accused_license_number || "",
      complaint: complaintData?.uu_id || null,
      status: ADVOCATE_INVESTIGATION_STATUS?.CLOSED,
    };
    const investigation_id = investigationData?.uu_id || "";
    const isFormData = false;

    try {
      const resData = await editInvestigation(
        data,
        investigation_id,
        isFormData,
      );

      if (resData) {
        await editComplaint({
          ...complaintData,
          status: COMPLIANT_STATUS.REJECTED_BY_COUNCIL_OFFICE,
        });
      }

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        reject_coment: "",
        reject_coment_date: "",
        complaint: null,
        status: ADVOCATE_INVESTIGATION_STATUS?.FORWARDED_TO_REGISTRAR,
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("rejectChargeDocument")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("date")}
            </label>
            <input
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              type={"date"}
              name="reject_coment_date"
              placeholder={t("datePlaceholder")}
              value={formState.reject_coment_date ?? ""}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("comment")}
            </label>
            <textarea
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              rows={4}
              name="reject_coment"
              placeholder={t("comment")}
              value={formState.reject_coment}
              onChange={handleChange}
            />
          </div>

          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("chargeFeedback")}
            </label>
            <textarea
              required
              rows={7}
              name="feedback"
              value={formState.feedback}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div> */}
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("submit")
          )}
        </button>
      </form>
    </SideModal>
  );
}
